import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePortalAuth } from '../contexts/PortalAuthContext';

const PortalPrivateRoute = () => {
  const { isAuthenticated, loading } = usePortalAuth();

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" />;
  }

  return <Outlet />;
};

export default PortalPrivateRoute;
